import { DomainSchema } from '@multitec/domain'
import { useQuery } from 'react-query'
import { z } from 'zod'

import { Base } from '../base'
import { MyURLSearchParams } from '../utils/url-search-params'

class Create extends Base {
  private body = z.object({
    name: z.string(),
    sku: z.string(),
    manufacturer: z.string().optional(),
    productType: z.enum(['PRODUTO', 'SERVICO']),
    // supplierId: z.string().optional(),
    buyPrice: z.number(),
    sellPrice: z.number(),
  })

  private response = z.object({
    id: z.string(),
  })

  handle = async (body: z.infer<typeof this.body>) => {
    const { data } = await this.axios.post('/entity/products/', body)
    return this.response.parse(data.result)
  }
}

class Edit extends Base {
  private body = z.object({
    name: z.string(),
    sku: z.string(),
    manufacturer: z.string().optional(),
    productType: z.enum(['PRODUTO', 'SERVICO']),
    // supplierId: z.string().optional(),
    buyPrice: z.number(),
    sellPrice: z.number(),
    active: z.boolean(),
  })

  private response = z.object({
    id: z.string(),
  })

  handle = async (id: string, body: z.infer<typeof this.body>) => {
    const { data } = await this.axios.put('/entity/products/' + id, body)
    return this.response.parse(data.result)
  }
}

class Search extends Base {
  private params = z.object({
    search: z.string().optional(),
    active: z.boolean().optional(),
    type: z.enum(['PRODUTO', 'SERVICO']).optional(),
  })

  private response = z.array(DomainSchema.Product)

  handle = (searchParams: z.infer<typeof this.params>) => {
    return useQuery(['products', 'search', { ...searchParams }], async () => {
      const queryParams = new MyURLSearchParams(searchParams).toString()
      const { data } = await this.axios.get('/entity/products?' + queryParams)
      return this.response.parse(data.result)
    })
  }
}

class LoadOne extends Base {
  private response = DomainSchema.Product

  handle = (id: string) => {
    return useQuery(['products', 'get-one', { id }], async () => {
      const { data } = await this.axios.get('/entity/products/' + id)
      return this.response.parse(data.result)
    })
  }
}

class ExportCSV extends Base {
  handle = async () => {
    const { data } = await this.axios.get('/entity/products/export')
    return data
  }
}

class ImportCSV extends Base {
  handle = async (formData: FormData) => {
    const { data } = await this.axios.post('/entity/products/import', formData)
    return data
  }
}

export default class extends Base {
  Create = new Create(this.axios).handle
  Edit = new Edit(this.axios).handle
  Search = new Search(this.axios).handle
  LoadOne = new LoadOne(this.axios).handle
  ExportCSV = new ExportCSV(this.axios).handle
  ImportCSV = new ImportCSV(this.axios).handle
}
